// extracted by mini-css-extract-plugin
export default {"bio-field-wrapper":"style_bio-field-wrapper__5ZMxl","bioFieldWrapper":"style_bio-field-wrapper__5ZMxl","location":"style_location__9HHrL"};